import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './GameChoice.module.scss';

// APIS 
import { getGame } from '../../utils/api/gamesAPI';
import { getAllParcoursByGame } from '../../utils/api/parcoursIndeAPI';

import { LanguageContext } from '../../context/LanguageContext';
import translations from '../../utils/translations/GameChoiceTranslations';

const GameChoice = () => {

    // Utilisation du contexte de langue global et accès simplifié aux traductions
    const { language } = useContext(LanguageContext);
    const t = translations[language] || translations.fr;

    const [game, setGame] = useState(null);
    const [parcours, setParcours] = useState([]);
    const [selectedParcoursId, setSelectedParcoursId] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        const fetchGame = async () => {
            try {
                const response = await getGame(1);//il faudrait l'extraire de l'URL...
                setGame(response);
              } catch (error) {
                console.error('Erreur:', error);
              }
        };
        fetchGame();
    }, []);

    // Nouveau useEffect pour récupérer les parcours après que game soit défini
    useEffect(() => {
        if (game) { // Vérifie que game n'est pas null avant d'exécuter la requête
            const fetchParcours = async () => {
                try {
                    const response = await getAllParcoursByGame(game.id);
                    setParcours(response);
                } catch (error) {
                    console.error('Erreur:', error);
                }
            };
            fetchParcours();
        }
    }, [game]); // Dépendance sur game

    // Gère la sélection d’un parcours
    const handleParcoursChange = (event) => {
        setSelectedParcoursId(event.target.value);
    };

    // Action du bouton Démarrer
    const handleStart = () => {
        // console.log('Le parcours sélectionné est :', selectedParcoursId);
        //Vérifier le code d'accès avant de rediriger !!!!
        navigate(`/start-game?game=${game.id}&parcours=${selectedParcoursId}`);
    };

  return (
    <div className={styles.container}>
        <h2>{game?.nom || ''}</h2>

        {/* Afficher la liste des parcours si dispo */}
        {parcours.length > 0 && (
            <div className={styles.selectGroup}>
            <label htmlFor="parcours-select" className={styles.label}>
                {t.selectParcoursLabel} 
            </label>
            <select
                id="parcours-select"
                className={styles.select}
                value={selectedParcoursId}
                onChange={handleParcoursChange}
            >
                <option value="" disabled>
                {t.selectParcoursPlaceholder}
                </option>
                {parcours.map((p) => (
                <option key={p.id} value={p.id}>
                    {p.name}
                </option>
                ))}
            </select>
            </div>
        )}

        {/* Affiche un message si aucun parcours n'est disponible */}
        {parcours.length === 0 && (
            <p className={styles.infoMessage}>
            {t.noParcoursAvailable}
            </p>
        )}

        {/* Bouton "Démarrer" : n’apparaît que si un parcours est sélectionné */}
        {selectedParcoursId && (
            <button
            type="button"
            onClick={handleStart}
            className={styles.startButton}
            >
            {t.startButton}
            </button>
        )}
        </div>
    );
};

export default GameChoice;
